// extracted by mini-css-extract-plugin
module.exports = {"root":"AttributesListItem_root__3zyZl","header":"AttributesListItem_header__2XUx2","actions":"AttributesListItem_actions__1v3-r"};